import {
    GET_DEVICES_REQUEST,
    GET_DEVICES_SUCCESS,
    GET_DEVICES_FAILURE,
    GET_DEVICES_STATUSES_REQUEST,
    GET_DEVICES_STATUSES_SUCCESS,
    GET_DEVICES_STATUSES_FAILURE,
    SUBMIT_DEVICES_REQUEST,
    SUBMIT_DEVICES_SUCCESS,
    SUBMIT_DEVICES_FAILURE,
    SUBMIT_DEVICES_BATCH_REQUEST,
    SUBMIT_DEVICES_BATCH_SUCCESS,
    SUBMIT_DEVICES_BATCH_FAILURE,
    SUBMIT_DEVICES_VALIDATE_BATCH_REQUEST,
    SUBMIT_DEVICES_VALIDATE_BATCH_SUCCESS,
    SUBMIT_DEVICES_VALIDATE_BATCH_FAILURE,
    CLEAN_VALIDATED_DEVICES,
    SUBMIT_DEVICES_STATUSES_REQUEST,
    SUBMIT_DEVICES_STATUSES_SUCCESS,
    SUBMIT_DEVICES_STATUSES_FAILURE,
    SET_STATE_DEVICES,
    SET_DEVICES_SELECTED,
    GET_TYPING_DEVICES_REQUEST,
    GET_EXPORT_DEVICES_REQUEST,
    GET_EXPORT_DEVICES_SUCCESS,
    GET_EXPORT_DEVICES_FAILURE,
    GET_DEVICES_SUBSTATUSES_REQUEST,
    GET_DEVICES_SUBSTATUSES_SUCCESS,
    GET_DEVICES_SUBSTATUSES_FAILURE,
    GET_HISTORY_DEVICES_REQUEST,
    GET_HISTORY_DEVICES_SUCCESS,
    GET_HISTORY_DEVICES_FAILURE,
    PATCH_DEVICES_REQUEST,
    PATCH_DEVICES_SUCCESS,
    PATCH_DEVICES_FAILURE
} from "../actions/devices";
import { buildDevices } from "../helpers/devices";
const initialState = {
    fetching: false,
    devices: [],
    device: {},
    total: 0,
    statuses: [],
    substatuses: [],
    statuesFetching: false,
    historyFetching: false,
    history: [],
    substatusesFetching: false,
    submitStatusesFetching: false,
    submitStatusesSucces: false,
    editFetching: false,
    submitFetching: false,
    submitSuccess: false,
    submitValidateBatchFetching: false,
    submitValidateBatchSuccess: false,
    devicesBatchValidations: {},
    exportableFileName: null,
    fetchingExport: false,
    isReadyForPatch: false
};

export default (state = initialState, action) => {
    switch (action.type) {
        case GET_DEVICES_REQUEST: {
            return {
                ...state,
                fetching: true
            };
        }
        case GET_DEVICES_SUCCESS: {
            const { devices, total, replace } = action.payload;
            const builtDevices = buildDevices(devices);
            
            return {
                ...state,
                fetching: false,
                devices: replace ? builtDevices : [...state.devices, ...builtDevices],
                total: total === 0 ? state.total : total
            };
        }
        case GET_DEVICES_FAILURE: {
            return {
                ...state,
                fetching: false
            };
        }
        case GET_TYPING_DEVICES_REQUEST: {
            return {
                ...state,
                fetching: true
            };
        }
        case GET_DEVICES_STATUSES_REQUEST: {
            return {
                ...state,
                statuses: [],
                statuesFetching: true
            };
        }
        case GET_DEVICES_STATUSES_SUCCESS: {
            return {
                ...state,
                statuses: action.payload.statuses,
                statuesFetching: false
            };
        }
        case GET_DEVICES_STATUSES_FAILURE: {
            return {
                ...state,
                statuesFetching: false
            };
        }
        case PATCH_DEVICES_REQUEST: {
            return {
                ...state,
                editFetching: true,
                submitSuccess: false
            };
        }
        case PATCH_DEVICES_SUCCESS: {
            return {
                ...state,
                editFetching: false,
                submitSuccess: true
            };
        }
        case PATCH_DEVICES_FAILURE: {
            return {
                ...state,
                editFetching: false,
                submitSuccess: false
            };
        }
        case GET_DEVICES_SUBSTATUSES_REQUEST: {
            return {
                ...state,
                substatuses: [],
                substatusesFetching: true
            };
        }
        case GET_DEVICES_SUBSTATUSES_SUCCESS: {
            return {
                ...state,
                substatuses: action.payload.substatuses || action.payload.substatus || [],
                substatusesFetching: false
            };
        }
        case GET_DEVICES_SUBSTATUSES_FAILURE: {
            return {
                ...state,
                substatusesFetching: false
            };
        }

        case GET_HISTORY_DEVICES_REQUEST: {
            return {
                ...state,
                history: [],
                historyFetching: true
            };
        }
        case GET_HISTORY_DEVICES_SUCCESS: {
            return {
                ...state,
                history: action.payload.history,
                historyFetching: false
            };
        }
        case GET_HISTORY_DEVICES_FAILURE: {
            return {
                ...state,
                historyFetching: false
            };
        }
        case SUBMIT_DEVICES_BATCH_REQUEST: {
            return {
                ...state,
                submitFetching: true,
                submitSuccess: false,
                isReadyForPatch: false
            };
        }
        case SUBMIT_DEVICES_BATCH_SUCCESS: {
            return {
                ...state,
                submitFetching: false,
                submitSuccess: true,
                isReadyForPatch: true
            };
        }
        case SUBMIT_DEVICES_BATCH_FAILURE: {
            return {
                ...state,
                submitFetching: false,
                submitSuccess: false,
                isReadyForPatch: false
            };
        }
        case SUBMIT_DEVICES_VALIDATE_BATCH_REQUEST: {
            return {
                ...state,
                submitValidateBatchFetching: true,
                submitValidateBatchSuccess: false
            };
        }
        case SUBMIT_DEVICES_VALIDATE_BATCH_SUCCESS: {
            return {
                ...state,
                submitValidateBatchFetching: false,
                submitValidateBatchSuccess: true,
                devicesBatchValidations: action.payload.validations
            };
        }
        case SUBMIT_DEVICES_VALIDATE_BATCH_FAILURE: {
            return {
                ...state,
                submitValidateBatchFetching: false,
                submitValidateBatchSuccess: false
            };
        }
        case CLEAN_VALIDATED_DEVICES: {
            return {
                ...state,
                submitValidateBatchFetching: false,
                submitValidateBatchSuccess: false,
                devicesBatchValidations: {}
            }
        }
        case SUBMIT_DEVICES_REQUEST: {
            return {
                ...state,
                submitFetching: true,
                submitSuccess: false
            };
        }
        case SUBMIT_DEVICES_SUCCESS: {
            return {
                ...state,
                submitFetching: false,
                submitSuccess: true
            };
        }
        case SUBMIT_DEVICES_FAILURE: {
            return {
                ...state,
                submitFetching: false,
                submitSuccess: false
            };
        }
        case SUBMIT_DEVICES_STATUSES_REQUEST: {
            return {
                ...state,
                submitStatusesFetching: true,
                submitStatusesSucces: false
            };
        }
        case SUBMIT_DEVICES_STATUSES_SUCCESS: {
            return {
                ...state,
                submitStatusesFetching: false,
                submitStatusesSucces: true
            };
        }
        case SUBMIT_DEVICES_STATUSES_FAILURE: {
            return {
                ...state,
                submitStatusesFetching: false,
                submitStatusesSucces: false
            };
        }
        case SET_STATE_DEVICES: {
            return {
                ...state,
                ...action.payload
            };
        }
        case SET_DEVICES_SELECTED: {
            return {
                ...state,
                device: action.payload.device
            };
        }
        case GET_EXPORT_DEVICES_REQUEST: {
            return {
                ...state,
                fetchingExport: true
            }
        }
        case GET_EXPORT_DEVICES_SUCCESS: {
            return {
                ...state,
                exportableFileName: action.payload.fileName,
                fetchingExport: false
            }
        }
        case GET_EXPORT_DEVICES_FAILURE: {
            return {
                ...state,
                fetchingExport: false
            }
        }
        default:
            return state;
    }
};
